export default (props, e) => {
  e.preventDefault();

  var footerAnchor = $('#js_FooterAnchor');
  $('html,body').animate({scrollTop: footerAnchor.offset().top}, 600);
}





// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/smoothScroll.js